import { render, staticRenderFns } from "./step3_garden.vue?vue&type=template&id=564699d9&scoped=true&"
import script from "./step3_garden.vue?vue&type=script&lang=js&"
export * from "./step3_garden.vue?vue&type=script&lang=js&"
import style0 from "./step3_garden.vue?vue&type=style&index=0&id=564699d9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564699d9",
  null
  
)

export default component.exports